export default function CalenderIcon({
  width = 16,
  height = 16,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66663 8.84892C4.66663 8.48078 4.96511 8.18225 5.33329 8.18225H5.33927C5.70747 8.18225 6.00594 8.48078 6.00594 8.84892C6.00594 9.21712 5.70747 9.51558 5.33927 9.51558H5.33329C4.96511 9.51558 4.66663 9.21712 4.66663 8.84892ZM7.33029 8.84892C7.33029 8.48078 7.62876 8.18225 7.99696 8.18225H8.00296C8.37116 8.18225 8.66963 8.48078 8.66963 8.84892C8.66963 9.21712 8.37116 9.51558 8.00296 9.51558H7.99696C7.62876 9.51558 7.33029 9.21712 7.33029 8.84892ZM9.99396 8.84892C9.99396 8.48078 10.2924 8.18225 10.6606 8.18225H10.6666C11.0348 8.18225 11.3333 8.48078 11.3333 8.84892C11.3333 9.21712 11.0348 9.51558 10.6666 9.51558H10.6606C10.2924 9.51558 9.99396 9.21712 9.99396 8.84892ZM4.66663 11.5156C4.66663 11.1475 4.96511 10.8489 5.33329 10.8489H5.33927C5.70747 10.8489 6.00594 11.1475 6.00594 11.5156C6.00594 11.8838 5.70747 12.1823 5.33927 12.1823H5.33329C4.96511 12.1823 4.66663 11.8838 4.66663 11.5156ZM7.33029 11.5156C7.33029 11.1475 7.62876 10.8489 7.99696 10.8489H8.00296C8.37116 10.8489 8.66963 11.1475 8.66963 11.5156C8.66963 11.8838 8.37116 12.1823 8.00296 12.1823H7.99696C7.62876 12.1823 7.33029 11.8838 7.33029 11.5156Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.075 0.833344C5.43399 0.833344 5.725 1.12504 5.725 1.48486V2.13638H10.275V1.48486C10.275 1.12504 10.566 0.833344 10.925 0.833344C11.284 0.833344 11.575 1.12504 11.575 1.48486V2.13638H12.55C13.6269 2.13638 14.5 3.01146 14.5 4.09092V13.2121C14.5 14.2916 13.6269 15.1667 12.55 15.1667H3.45C2.37305 15.1667 1.5 14.2916 1.5 13.2121V4.09092C1.5 3.01146 2.37305 2.13638 3.45 2.13638H4.425V1.48486C4.425 1.12504 4.71602 0.833344 5.075 0.833344ZM13.1999 6.50001H2.79997V13.2121C2.79997 13.5719 3.09098 13.8637 3.44997 13.8637H12.5499C12.9089 13.8637 13.1999 13.5719 13.1999 13.2121V6.50001Z"
        fill={color}
      />
    </svg>
  );
}
